<template>
    <div
        class="preview__model"
        @mousedown="(e) => (e.target.style.cursor = 'grabbing')"
        @mouseup="(e) => (e.target.style.cursor = 'grab')"
    >
        <UiFormLoader v-show="!hasFinishLoading" :is-dark="true" />
        <ClientOnly>
            <TresCanvas v-bind="settings">
                <Suspense>
                    <ModelComponent />
                </Suspense>
                <Suspense>
                    <Environment files="/media/environments/aircraft.hdr" :near="1" :far="10" />
                </Suspense>
                <OrbitControls :enable-pan="false" :enable-zoom="false" :auto-rotate="true" :auto-rotate-speed="0.5" />
                <TresPerspectiveCamera
                    :position="[0, 0, 1]"
                    :look-at="[0, 0, 0]"
                    :fov="20"
                    :aspect="1"
                    :near="0.1"
                    :far="100"
                />
                <TresDirectionalLight color="#ffffff" :position="[1, 1, 1]" :intensity="3" />
                <TresAmbientLight :intensity="2" />
            </TresCanvas>
        </ClientOnly>
    </div>
</template>

<script setup>
    import { h } from "vue";
    import { TresCanvas } from "@tresjs/core";
    import { OrbitControls, useGLTF, useProgress } from "@tresjs/cientos";
    import { Box3 } from "three/src/math/Box3.js";
    import { Vector3 } from "three/src/math/Vector3.js";
    import { NeutralToneMapping } from "three/src/constants.js";

    const props = defineProps({
        url: {
            type: String,
            default: ""
        },
        color: {
            type: Array,
            default: () => []
        }
    });

    const settings = {
        alpha: true,
        antialias: true,
        shadows: false,
        renderMode: "always",
        toneMapping: NeutralToneMapping,
        toneMappingExposure: 1,
        useLegacyLights: true,
        enableProvideBridge: true,
        windowSize: false
    };

    // nodes
    // animations

    const { scene: model, materials } = await useGLTF(props.url, { draco: true });
    const { hasFinishLoading } = await useProgress();

    const ModelComponent = () => h("primitive", { object: model });

    const box = new Box3().setFromObject(model);
    const center = box.getCenter(new Vector3());
    model.position.sub(center);
    
    const setMaterialColor = (color) => {
        for (const [key, obj] of Object.entries(materials)) {
            if (key == "Body" || key == "Body_cut") {
                // obj.color = new Color().setHex(`0x${color}`);
                // obj.roughness = 0.5;
            }

            if (key == "Labels") {
                // obj.color = new Color().setHex(`0x${color == "1f1d18" ? "ffffff" : "1f1d18"}`);
            }
        }
    };

    watch(
        () => props.color,
        (state) => setMaterialColor(state[0].color.slice(1))
    );

    setMaterialColor(props.color[0].color.slice(1));
</script>
